import { render, staticRenderFns } from "./AboutService.vue?vue&type=template&id=702be70f&"
import script from "./AboutService.vue?vue&type=script&lang=js&"
export * from "./AboutService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports